module.exports = __webpack_public_path__ + "static/media/app03_jpn.32c25458.png";